import { isSuperAdminRoleType } from './accountRoleClassification';
import { isReportingSupervisorValue } from './behaviourAccess';
import { isPendingLeaveStatus } from './leaveStatus';

const CAN_LEAVE_ACCESS_ROLE_TYPES = new Set(['assistant_manager_002']);

export function hasCanLeaveAccess(roleType) {
  const normalized = String(roleType || '').trim().toLowerCase();
  if (isSuperAdminRoleType(normalized)) return true;
  return CAN_LEAVE_ACCESS_ROLE_TYPES.has(normalized);
}

export function leaveApplyStatusForRole(roleType) {
  return hasCanLeaveAccess(roleType) ? 'approved' : 'pending';
}

export function canSeeTeamLeaveList({ roleType, isReportingSupervisor } = {}) {
  return hasCanLeaveAccess(roleType) || isReportingSupervisorValue(isReportingSupervisor);
}

function isFinalLeaveStatus(status) {
  return /approved|rejected|cancel/i.test(String(status || ''));
}

function canCancelLeaveStatus(status) {
  const value = String(status || '').trim().toLowerCase();
  return value === 'requested' || value === 'pending';
}

/**
 * Action buttons for a leave row:
 * - Super Admin / assistant_manager_002 (others' leave): View, Accept, Reject
 * - Reporting supervisor on a report's leave: View, Accept, Reject
 * - Own leave (employee or supervisor): View, Edit (pending), Cancel (pending/requested)
 */
export function getLeaveRowActionFlags({
  status,
  isOwnLeave,
  roleType,
  isReportingSupervisor,
} = {}) {
  const isFinal = isFinalLeaveStatus(status);
  const showEdit = Boolean(isOwnLeave) && isPendingLeaveStatus(status);
  const isSupervisor = isReportingSupervisorValue(isReportingSupervisor);

  if (isSuperAdminRoleType(roleType)) {
    return {
      isFinal,
      showEdit: false,
      showCancel: false,
      showAcceptReject: true,
    };
  }

  if (!isOwnLeave && (isSupervisor || hasCanLeaveAccess(roleType))) {
    return {
      isFinal,
      showEdit: false,
      showCancel: false,
      showAcceptReject: true,
    };
  }

  return {
    isFinal,
    showEdit,
    showCancel: canCancelLeaveStatus(status),
    showAcceptReject: false,
  };
}
